export default __webpack_public_path__ + "static/tech-one-0573f5c0548e879d8abceb1d1ddc8cbf.jpg";